import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Upload } from './upload/upload';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';
import * as firebase from 'firebase';

import { Globals } from '../globals';
import { toast } from 'angular2-materialize';

export interface PrClient {
  active: number;
  createdAt: any;
  updatedAt: any;
  //actuals
  customerId: string;
  employeeId: string;
  prVntaId: string;
  isLineProduct: boolean;
  isLastVersion: boolean;
  codeGivenBy: string;
  code: string;
  version: string;
  barCode?: string;
  designStatus?: string;
  designComments?: string;
  qualityStatus?: string;
  qualityComments?: string;
  shortDescription?: string;
  longDescription?: string;
  processOwnerComments?: string;
  newVersionMotive?: string;
  quotationId?: string;
  sections: any[];
  generalActivities: any[];

  //new
  IDPln: string;
  agreedPrice: number;// PrecioAcordado
  characteristics: string;// Caracteristicas
  agreedDate: string;// FechaPrecioAcordado
  packaging: Packaging;// EmpacAncho, EmpacLargo, EmpacAlto
  valid: number;// Valido
  pasteType: number;// TipoPegado
  flatNumber: string;// NumPlano
}
interface Packaging{
  wide: number;
  long: number;
  height: number;
}
export interface PrClientId extends PrClient {
  id: string;
}

@Injectable()
export class ProductClientService {

  prClientCollection: AngularFirestoreCollection<PrClient>;
  prClients: any;

  prClientDocument: AngularFirestoreDocument<PrClientId>;
  prClient: Observable<PrClientId>;

  collection: string;
  collectionClient: string;
  collectionEmployee: string;
  collectionPrVnta: string;
  collectionQuotation: string;
  companyCollection: string;
  companyId: string;

  // NOTE: Change this any for PrClient Interface
  prClient$: Observable<any>;
  prClients$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router,
  ) {
    this.collection = Globals.PRCLIENT_COLLECTION;
    this.collectionClient = Globals.CUSTOMER_SUPPLIER_COLLECTION;
    this.collectionEmployee = Globals.EMPLOYEE_COLLECTION;
    this.collectionPrVnta = Globals.PRVNTA_COLLECTION;
    this.collectionQuotation = Globals.QUOT_COLLECTION;
    this.companyCollection = Globals.COMPANIES_COLLECTION;
    this.companyId = Globals.AGRO_VIVA_DOCUMENT_ID;
  }

  /**
   * Get all prClients with references
   * @return {Observable} Arrays of prClients
   */
  getPrClients({customerId='', onEmpty=undefined}={}) {
    console.log(`getting for '${customerId}'`);
    let col;
    if(customerId) col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('customerId', '==', customerId) );
    else col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
    return col.map(documents => {
      console.log('docs:', documents);
      if(!documents.length && onEmpty) onEmpty();
      return documents.map((document,index) => {
        const clientRef = this.afh.docWithIds$(`${this.collectionClient}/${document.customerId}`);
        const employeeRef = this.afh.docWithIds$(`${this.collectionEmployee}/${document.employeeId}`);
        const prVntaRef = this.afh.docWithIds$(`${this.collectionPrVnta}/${document.prVntaId}`);
        const quotRef = document.quotationId ? this.afh.docWithIds$(`${this.collectionQuotation}/${document.quotationId}`) : undefined;
        if(quotRef)
        return Observable.combineLatest(
          clientRef,
          employeeRef,
          prVntaRef,
          quotRef,
          (clientData, employeeData, prVntaData, quotData) => ({ client: clientData, employee: employeeData, prVnta: prVntaData, quot: quotData })
        ).map(data => ({ customerObj: data.client, employeeObj: data.employee, prVntaObj: data.prVnta, quotObj: data.quot, ...document }) );

        else
        return Observable.combineLatest(
          clientRef,
          employeeRef,
          prVntaRef,
          (clientData, employeeData, prVntaData) => ({ client: clientData, employee: employeeData, prVnta: prVntaData })
        ).map(data => ({ customerObj: data.client, employeeObj: data.employee, prVntaObj: data.prVnta, ...document }) );

      });
    }).mergeMap(prClientsDocuments => Observable.combineLatest(prClientsDocuments));
  }

  /**
  * Get prClient data
  * @param {string} sid - The id of the prClient
  * @return {Observable} The PrClient Object
  */
  getPrClient(sid: string) {
    return this.prClient$ = this.afh.docWithIds$(this.collection + '/' + sid).map(document => {
      const clientRef = this.afh.docWithIds$(`${this.collectionClient}/${document.customerId}`);
      const employeeRef = this.afh.docWithIds$(`${this.collectionEmployee}/${document.employeeId}`);
      const prVntaRef = this.afh.docWithIds$(`${this.collectionPrVnta}/${document.prVntaId}`);
      const quotRef = document.quotationId ? this.afh.docWithIds$(`${this.collectionQuotation}/${document.quotationId}`) : undefined;

      if(quotRef)
      return Observable.combineLatest(
        clientRef,
        employeeRef,
        prVntaRef,
        this.afh.docWithIds$(`${this.companyCollection}/${this.companyId}`),
        quotRef,
        (clientData, employeeData, prVntaData, companyData, quotData) => ({ client: clientData, employee: employeeData, prVnta: prVntaData, company: companyData, quot: quotData })
      ).map(data => ({ customerObj: data.client, employeeObj: data.employee, prVntaObj: data.prVnta, companyObj: data.company, quotObj: data.quot, ...document }) );

      else
      return Observable.combineLatest(
        clientRef,
        employeeRef,
        prVntaRef,
        this.afh.docWithIds$(`${this.companyCollection}/${this.companyId}`),
        (clientData, employeeData, prVntaData, companyData) => ({ client: clientData, employee: employeeData, prVnta: prVntaData, company: companyData })
      ).map(data => ({ customerObj: data.client, employeeObj: data.employee, prVntaObj: data.prVnta, companyObj: data.company, ...document }) );
      
    }).mergeMap(prClientsDocuments => Observable.combineLatest(prClientsDocuments));
  }


  /**
  * Create new prClient
  * @param {PrClient} prClient - The data of the prClient
  */
  addPrClient(prClient: PrClient) {
    return this.afh.add(`${this.collection}`, prClient);
  }

  /**
   * Update current prClient
   * @param {string} sid  - The id of the prClient
   * @param {PrClient} prClient - The data of the prClient
   */
  updatePrClient(sid: string, prClient: any) {
    this.afh.update(`${this.collection}/${sid}`, prClient).then(res => {
      console.log('updated');
    }).catch(e => {
      console.log('error', sid, e);
    });
  }

  /**
   * Delete current prClient
   * @param {string} sid - The id of the prClient
   */
  deletePrClient(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_prClient`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_prClient/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_prClient/${id}`]);
        break;
      case 'read':
        this.router.navigate([`prClient`]);
        break;
      default:
        console.log('Not an action');
    }
  }

  uploadFile(upload: Upload, product, index) {
    const id = product.id;
    var prClient = product;
    const imageName = `${this.makeImageId}_${prClient.sections[index].name}`;
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(`${this.collection}/${id}/sections/${imageName}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    }, (err) => {
      console.log('error al subir');
    }, () => {
      prClient.sections[index].fileURL = uploadTask.snapshot.downloadURL;
      prClient.sections[index].fileName = imageName;
      this.afh.update(`${this.collection}/${id}`, {sections: prClient.sections});
    });
  }
  deleteFile(product, index){
    const id = product.id;
    var prClient = product;
    const imageName = prClient.sections[index].fileName;
    const storageRef = firebase.storage().ref();
    var imageToDeleteRef = storageRef.child(`${this.collection}/${id}/sections/${imageName}`);
    imageToDeleteRef.delete();
    delete prClient.sections[index].fileURL;
    delete prClient.sections[index].fileName;
    this.afh.update(`${this.collection}/${id}`, {sections: prClient.sections});
  }
  deleteFileNoUpdate(id, imageName){
    const storageRef = firebase.storage().ref();
    var imageToDeleteRef = storageRef.child(`${this.collection}/${id}/sections/${imageName}`);
    imageToDeleteRef.delete();
  }
  get makeImageId(){
    const OPTS = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz";
    return [...Array(11)].reduce((acc, cur) => `${acc}${OPTS.charAt(Math.floor(Math.random() * OPTS.length))}`, '');
  }

  prClientHasFile(prClient: PrClient){
    return prClient.sections.some(({fileURL}) => fileURL);
  }
}

export class PrClientData{
  pasteTypeSelect = {
    '1': {name: 'Lineal'},
    '2': {name: 'Fondo Automático'},
    '3': {name: '4 Esquinas'},
    '4': {name: 'Doble Pared'},
    '5': {name: 'Otro'},
    '6': {name: 'No Especificado'},
  }

  allSelects = {
    pasteType: Object.keys(this.pasteTypeSelect).map(key => ({value: key, name: this.pasteTypeSelect[key].name}) ),
  }
}

/* export class PR_CLIENT{
  customerId: string;
  employeeId: string;
  prVntaId: string;
  isLineProduct: boolean;
  isLastVersion: boolean;
  codeGivenBy: string;// Automatico
  code: string;
  version: string;
  barCode?: string;
  designStatus?: string;
  designComments?: string;
  qualityStatus?: string;
  qualityComments?: string;
  shortDescription?: string;
  longDescription?: string;
  processOwnerComments?: string;
  newVersionMotive?: string;
  quotationId?: string;
  sections: any[];
  generalActivities: any[];

  //new
  IDPln: string;
  agreedPrice: number;// PrecioAcordado
  characteristics: string;// Caracteristicas
  agreedDate: string;// FechaPrecioAcordado
  packaging: Packaging = { wide: 0, long: 0, height: 0 };// EmpacAncho, EmpacLargo, EmpacAlto
  valid: number;// Valido
  pasteType: number;// TipoPegado
  flatNumber: string;// NumPlano

  prClient;
  
  constructor({wide, long, height, customerDescription, employeeFolio, prVntaName, isLineProduct, codeGivenBy, ...prClientObj}){
    prClientObj.packaging = {wide, long, height};
    prClientObj.customerId = JSON.parse(localStorage.customersJson)[customerDescription] || console.log('error_cus ' + customerDescription);
    prClientObj.employeeId = JSON.parse(localStorage.employeesJson)[employeeFolio] || console.log('error_emp ' + employeeFolio);
    prClientObj.prVntaId = JSON.parse(localStorage.prVntasJson)[prVntaName.replace('orbata.','orbata')] || console.log('error_prv ' + prVntaName);
    prClientObj.isLineProduct = isLineProduct == 'TRUE';
    prClientObj.codeGivenBy = codeGivenBy == 'FALSO' ? 'Manual' : 'Automática';

    prClientObj.isLastVersion = false;
    prClientObj.processOwnerComments = '';
    prClientObj.quotationId = '';
    prClientObj.sections = [];
    prClientObj.generalActivities = [];

    this.prClient = prClientObj;
  }
} */

/* class SECTION{
  prClientId: string = '';
  activities: any[] = [];
  backInk: number = 0;
  frontInk:number = 0;
  height: number = 0;
  inks = {
    back: Array(8).fill(''),
    front: Array(8).fill('')
  }
  name: string = '';
  numPages: number = 1;
  pieceInSize: number = 0;
  pieceHeight: number = 0;
  pieceLong: number = 0;
  pieceWidth: number = 0;
  sheetHeight: number = 0;
  sheetWidth: number = 0;
  sizeInPaper: number = 0;
  width: number = 0

  constructor({ PLn_ID, sectionName='', prCmpaDesc, width, height, pieceInSize, sizeInPaper, sheetWidth, sheetHeight, frontInk, backInk, suajeCode, barniz1Name, barniz2Name, pieceWidth, pieceLong, pieceHeight, ...inks }){
    this.prClientId = prClientPlns[PLn_ID] || console.log('error prClient --> ' + PLn_ID);
    if(prCmpaDesc) this.activities.push({ name: '101 - Sustrato', classification: '1-PrePrensa', quantityPricesFunction: 'papel', dataCalc: 1, prices: [0], ranges: [], unique: {prCmpaDescription: prCmpa_desc_characs[prCmpaDesc] || ''} });
    if(suajeCode) this.activities.push({ name: '307 - Suaje', classification: '3-PostPrensa', quantityPricesFunction: 'suaje', dataCalc: 3, prices: [0,0,0], ranges: [], unique: {suajeDescription: suajeCode} });
    if(barniz1Name) this.activities.push({ name: `304 - Barniz - ${barniz1Name}`, classification: '3-PostPrensa', quantityPricesFunction: 'barnizSuaje', dataCalc: 2, prices: [0,0], ranges: [] });
    if(barniz2Name) this.activities.push({ name: `304 - Barniz - ${barniz2Name}`, classification: '3-PostPrensa', quantityPricesFunction: 'barnizSuaje', dataCalc: 2, prices: [0,0], ranges: [] });
    this.backInk = Math.floor(+(backInk.replace(',','.'))*1000)/1000;
    this.frontInk = Math.floor(+(frontInk.replace(',','.'))*1000)/1000;
    this.height = Math.floor(+(height.replace(',','.'))*1000)/1000;
    Object.keys(inks).map(key => { let [where, index] = key.split('_'); this.inks[where][index] = inks[key] && inks[key] != 'N/A' ? inks[key] : ''; });
    this.name = sectionName;
    this.pieceInSize = Math.floor(+(pieceInSize.replace(',','.'))*1000)/1000;
    this.pieceHeight = Math.floor(+(pieceHeight.replace(',','.'))*1000)/1000;
    this.pieceLong = Math.floor(+(pieceLong.replace(',','.'))*1000)/1000;
    this.pieceWidth = Math.floor(+(pieceWidth.replace(',','.'))*1000)/1000;
    this.sheetHeight = Math.floor(+(sheetHeight.replace(',','.'))*1000)/1000;
    this.sheetWidth = Math.floor(+(sheetWidth.replace(',','.'))*1000)/1000;
    this.sizeInPaper = Math.floor(+(sizeInPaper.replace(',','.'))*1000)/1000;
    this.width = Math.floor(+(width.replace(',','.'))*1000)/1000;
  }

}

var prClientPlns = JSON.parse(localStorage.prClientPln);
var prCmpa_desc_characs = JSON.parse(localStorage.prCmpa_desc_characs);//

let json = localStorage.sections;
export var SECTIONS = JSON.parse(json).map(obj => new SECTION(obj)); */



